import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import * as React from "react";
import { Platform, StatusBar, StyleSheet, View, Text } from "react-native";

import * as eva from "@eva-design/eva";
import { ApplicationProvider } from "@ui-kitten/components";

import MainMenuButton from "./components/MainMenuButton";
import BlueBarCodeButton from "./components/BlueBarCodeButton";
import BackButton from "./components/BackButton";
import LaunchFilterButton from "./components/LaunchFilterButton";
import useCachedResources from "./hooks/useCachedResources";
import LinkingConfiguration from "./navigation/LinkingConfiguration";
import { Auth, Hub } from "aws-amplify";
import { useSelector } from "react-redux";
import { Provider } from "react-redux";
import store from "./redux/storeConfig";
import { user_login } from "./redux/actions/UserActions";
import { default as mapping } from "./screens/invest/mapping.json";

// UNORGANIZED SCREENS
import MainMenuScreen from "./screens/MainMenuScreen";
import AuraCardsScreen from "./screens/AuraCardsScreen";
import InvestScreen from "./screens/InvestScreen";
import InvestModify from "./screens/InvestModifyScreen";
import InvestOptionDetail from "./screens/InvestOptionDetailScreen";
import InviteScreen from "./screens/InviteScreen";
import AboutUsScreen from "./screens/AboutUsScreen";
import InviteMultipleFriendsScreen from "./screens/InviteMultipleFriendsScreen";
import BarCodeScreen from "./screens/BarCodeScreen";
import LinkingConfirmationScreen from "./screens/LinkingConfirmationScreen";

// NOTIFICATION SCREENS
import NotificationScreen from "./screens/NotificationScreen";
import NotificationUnlinkScreen from "./screens/NotificationUnlinkScreen";
import NoCharityNotifactionScreen from "./screens/Notifications/noCharityNotification";
import WithdrawalNotificationConfirmScreen from "./screens/Notifications/withdrawalNotification"


// SETTINGS SCREENS
import SettingsScreen from "./screens//Settings/SettingsScreen";
import SettingsProfileScreen from "./screens//Settings/SettingsProfileScreen";
import ToggleDeveloperModeScreen from "./screens/Settings/ToggleDeveloperModeScreen";
import StatementScreen from "./screens/Settings/StatementScreen";
import NotificationListScreen from "./screens/Settings/NotificationListScreen";

// SHELL SCREENS
import PromotionalLandingScreen from "./screens/shell/PromotionalLandingScreen";
import ConsentScreen from "./screens/shell/ConsentScreen";
import RedeemLandingScreen from "./screens/shell/RedeemLandingScreen";
import ShellBarcodeScreen from "./screens/shell/ShellBarcodeScreen";


// NAVIGATION STACKS
import InvestScreens from "./screens/invest/investNavigationStack";
import CardsScreens from "./screens/cards/CardsNavigationStack";
import buyNavigationStack from "./screens/buy/NavigationStackBuy";
import onboardingNavigationStack from "./screens/onboarding/NavigationStackOnboarding";
import unauthenticatedNavigationStack from "./screens/unauthenticated/NavigationStackUnauthenticated";
import donateNavigationStack from "./screens/donate/NavigationStackDonate";
import transactionsNavigationStack from "./screens/transactions/NavigationStackTransactions";
import WebBuyNavigationStack from "./screens/webBuy/NavigationStackWebBuy";

// DEPRECIATED SCREENS
// import SelectPartnersScreen from "./screens/depreciated/SelectPartnersScreen";
// import SelectPartnersSingleScreen from "./screens/depreciated/SelectPartnersSingleScreen";
// import SelectPartnerSubcategoryScreen from "./screens/depreciated/SelectPartnerSubCategoryScreen";
// import PartnerCategoryScreen from "./screens/depreciated/PartnerCategoryScreen";
// import PartnerDetailScreen from "./screens/depreciated/PartnerDetailScreen";
// import PartnerSignUpScreen from "./screens/depreciated/PartnerSignUpScreen";
// import PartnerSignOffScreen from "./screens/depreciated/PartnerSignOffScreen";

// import WebViewScreen from "./screens/Settings/WebViewScreen";

function getCachedAuthentication() {
  Auth.currentAuthenticatedUser().then(
    (value) => {
      if (value.user === null) {
        return [false, null];
      } else {
        // store.dispatch({ type: "USER_LOGIN", user: value });
        user_login(value);
        // console.log(value);
        return [true, value.user];
      }
    },
    () => {
      return [false, null];
    }
  );
}
function getCBaseUrl() {
  let getUrl = window.location;
  let baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
  return baseUrl
}

function MainView(props) {
  const authState = useSelector((state) => state.user.loggedIn);

  //ADD to force text not to scale
  if (Text.defaultProps == null) {
    Text.defaultProps = {};
    Text.defaultProps.allowFontScaling = false;
  }

  return (
    <ApplicationProvider {...eva}
      theme={eva.light}
      customMapping={mapping}>
      <View style={styles.container}>
        <StatusBar hidden={true} />
        {Platform.OS === "ios" && <StatusBar barStyle="dark-content" />}
        <NavigationContainer linking={LinkingConfiguration}
          onStateChange={() => Platform.OS === "web" ? window.history.replaceState({ foo: "bar" }, '', getCBaseUrl()) : null} >
          <Stack.Navigator
            screenOptions={{
              headerStyle: {
                backgroundColor: "#ffffff",
                borderBottomWidth: 0,
                shadowColor: "transparent",
                elevation: 0,
                shadowOpacity: 0,
              },
              headerTintColor: "#000",
              headerTitleStyle: { fontWeight: "bold" },
              headerTitle: "",
              headerLeft: () => <BackButton />,
            }}
          >
            {authState === false ? (
              <>
                {unauthenticatedNavigationStack()}
                {WebBuyNavigationStack()}
              </>
            ) : (
              <>
                <Stack.Screen
                  name="MainMenu"
                  component={MainMenuScreen}
                  options={{ headerShown: false }}
                />

                <Stack.Screen
                  name="AuraCards"
                  component={AuraCardsScreen}
                  options={{
                    title: null,
                    headerShown: false,
                    headerRight: () => <BlueBarCodeButton />,
                  }}
                />
                <Stack.Screen
                  name="Invest"
                  component={InvestScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="InvestModify"
                  component={InvestModify}
                  options={{ title: null, headerRight: () => <MainMenuButton /> }}
                />
                <Stack.Screen
                  name="InvestOptionDetail"
                  component={InvestOptionDetail}
                  options={{ title: null, headerRight: () => <MainMenuButton /> }}
                />
                <Stack.Screen
                  name="InviteFriends"
                  component={InviteScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                />
                <Stack.Screen
                  name="InviteMultipleFriends"
                  component={InviteMultipleFriendsScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                />
                {/* <Stack.Screen
                  name="SelectPartners"
                  component={SelectPartnersSingleScreen}
                  options={{ title: null, headerShown: false }}
                /> */}
                {/* <Stack.Screen
                  name="PartnerSubCatSelect"
                  component={SelectPartnerSubcategoryScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                /> */}
                {/* <Stack.Screen
                  name="PartnerCategory"
                  component={PartnerCategoryScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                /> */}
                {/* <Stack.Screen
                  name="PartnerDetail"
                  component={PartnerDetailScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                /> */}
                {/* <Stack.Screen
                  name="PartnerSignUp"
                  component={PartnerSignUpScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                /> */}
                {/* <Stack.Screen
                  name="PartnerSignOff"
                  component={PartnerSignOffScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                /> */}
                <Stack.Screen
                  name="LinkingConfirmationScreen"
                  component={LinkingConfirmationScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="Settings"
                  component={SettingsScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="SettingsProfile"
                  component={SettingsProfileScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="SettingsDebugMode"
                  component={ToggleDeveloperModeScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="Statement"
                  component={StatementScreen}
                  options={{ title: null, headerShown: false }}
                />
                {/* <Stack.Screen
                name="WebView"
                component={WebViewScreen}
                options={{ title: null, headerShown: false }}
              /> */}
                <Stack.Screen
                  name="AboutUs"
                  component={AboutUsScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                />
                <Stack.Screen
                  name="BarCode"
                  component={BarCodeScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="Notification"
                  component={NotificationScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="NotificationUnlink"
                  component={NotificationUnlinkScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="NoCharityNotifaction"
                  component={NoCharityNotifactionScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="WithdrawalNotificationConfirm"
                  component={WithdrawalNotificationConfirmScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="PromotionalLanding"
                  component={PromotionalLandingScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="Consent"
                  component={ConsentScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="RedeemLanding"
                  component={RedeemLandingScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="ShellBarcode"
                  component={ShellBarcodeScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="NotificationListScreen"
                  component={NotificationListScreen}
                  options={{ headerShown: false }}
                />
                {InvestScreens()}
                {CardsScreens()}
                {buyNavigationStack()}
                {onboardingNavigationStack()}
                {donateNavigationStack()}
                {transactionsNavigationStack()}
              </>
            )}
          </Stack.Navigator>
        </NavigationContainer>
      </View ></ApplicationProvider>
  );
}

const Stack = createStackNavigator();
export default function App(props) {
  const isLoadingComplete = useCachedResources();
  // const [authState, authStateChange] = React.useState('');

  React.useEffect(() => {
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          getCachedAuthentication();
          break;
        case "signOut":
          break;
      }
    });
  }, []);

  var user = {};
  getCachedAuthentication();
  if (!isLoadingComplete) {
    return null;
  } else {
    return (
      <Provider store={store}>
        <MainView />
      </Provider>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
});
